import { useEffect, useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { listPosts } from '../graphql/queries'; 
import { marked } from 'marked'; 

const client = generateClient();

export default function JobInfo({ selectedFilters }) {
  const { location: locations = [], 'Employment type': types = [] } = selectedFilters;
  const [posts, setPosts] = useState([]);
  const [expandedState, setExpandedState] = useState({}); 

  useEffect(() => {
    async function fetchPosts() {
      try {
        const result = await client.graphql({ query: listPosts });
        const posts = result.data.listPosts.items;
        setPosts(posts);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    }

    fetchPosts();
  }, []);

  const filteredPosts = posts.filter(post =>
    (locations.length === 0 || locations.some(loc => post.location.toLowerCase().includes(loc.toLowerCase()))) &&
    (types.length === 0 || types.some(type => post.type.toLowerCase().includes(type.toLowerCase())))
  );

  const toggleExpanded = (id) => {
    setExpandedState(prevState => ({
      ...prevState,
      [id]: !prevState[id]  // Toggle the expanded state for each post
    }));
  };

  const handleApplyNow = (post) => {
    const subject = encodeURIComponent(`Application for ${post.title}`);
    const body = encodeURIComponent(`I am interested in applying for the position of ${post.title} located in ${post.location} as a ${post.type}. Please find my application attached.`);
    window.location.href = `mailto:info@enhancedwellbeing.com.au?subject=${subject}&body=${body}`;
  };

  return (
    <div className="w-full bg-white bg-opacity-60 py-0 sm:py-0">
      {filteredPosts.map((post) => (
        <article key={post.id} className="w-full flex flex-col items-start justify-between p-4 shadow rounded-lg">
          <div className="flex items-center gap-x-4 text-sm">
            <p className="rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">
              {post.location}
            </p>
            <p className="rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">
              {post.type}
            </p>
          </div>
          <div className="relative">
            <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900">
              {post.title}
            </h3>
            <div className={`text-sm leading-6 text-gray-600 mt-2 ${!expandedState[post.id] ? 'line-clamp-5' : ''}`}>
              <div
                dangerouslySetInnerHTML={{ __html: marked(post.description.join("\n")) }} 
                className="prose"  
              />
            </div>
            {expandedState[post.id] && (
              <div className="flex flex-col items-start mt-2">
                <button className="inline-block py-2 px-4 font-semibold text-white rounded transition duration-150 ease-in-out bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 hover:from-red-600 hover:via-pink-600 hover:to-purple-600"
                  onClick={() => handleApplyNow(post)}>
                  Apply Now
                </button>
                <button onClick={() => toggleExpanded(post.id)} className="mt-1 text-blue-500 hover:text-blue-700 text-sm">
                  Show Less
                </button>
              </div>
            )}
            {!expandedState[post.id] && (
              <button onClick={() => toggleExpanded(post.id)} className="text-blue-500 hover:text-blue-700 text-sm mt-2">
                Show More
              </button>
            )}
          </div>
        </article>
      ))}
    </div>
  );
}

